import styled from 'styled-components';
import Collapse from 'react-bootstrap/Collapse';

export const Container = styled.div`
    select{
        animation: flipInX;
        animation-duration: 1s;
        border-radius: 4px;
        cursor: pointer;
        padding: 0 6px ;
        border: 1px solid #ECECF3;
        color: #7F7F8A;
        height: 40px;

        option{
            background-color: #F6F8FA;
            color: black;
            cursor: pointer;
        }

        &:focus-visible{
            outline: none;
        }

        &:disabled{
            background-color: #e9ecef;
            border-radius: 5px;
            border: 1px solid #ced4da;
            cursor: auto;
        }
    }

    label{
        animation: flipInX;
        animation-duration: 1s;
    }

    .form-check{
        color: #7F7F8A;
        animation: flipInX;
        animation-duration: 1s;
    }

    input{
        &:focus{
            box-shadow: none;
        }
    }

    button{
        border-radius: 5px;
        color: #fff;
        margin-right: 19px;
        font-size: 13px;
        cursor: pointer;
        font-weight: bold;
        display: inline-block !important;
        vertical-align: middle !important;
        animation: flipInX;
        animation-duration: 1s;

        &:hover{
            opacity: 0.8;
        }
    }

    .apply-btn{
        background-color: #112A61;
        border: 1px solid #112A61;
        padding-top: 10px;
        padding-bottom: 10px;
        cursor: pointer;
    }
`;

export const Table = styled.table`
    font-size: 13px;
    width: 100%;
    animation: fadeIn;
    animation-duration: 1s;

    thead{
        background-color: #112A61;
        height: 40px;
        z-index: 2;

        tr{
            th{
                font-weight: bold;
                color: #FFFFFFFF;
                padding: 14px;
                text-align: left;
                vertical-align: middle;

                &.text-center {
                    text-align: center;
                }
            }

            th:first-child{
                border-radius: 8px 0px 0px 0px;
            }

            th:last-child{
                border-radius: 0px 8px 0px 0px;
            }
        }

        &.sticky-top{
            top: -1px!important;
        }
    }

    tbody{
        background-color: #FFFFFFFF;
        box-shadow: 0px 3px 20px #0000000d;

        tr{
            border: 1px solid #ECECF3;
            border-left: #FFFFFF;
            border-right: #FFFFFF;

            &.shadow-box{
                box-shadow: 0 4px 2px -2px gray;
            }

            td{
                padding: 14px;
                vertical-align: middle; /* Alinha texto e botão no meio da linha */

                &.text-center {
                    text-align: center !important;
                }

                &:last-child{
                    /* Removemos o float:right para o ChatWrapper controlar o alinhamento */
                    svg{
                        &:hover{
                            opacity: 0.5;
                            cursor: pointer;
                        }
                    }
                }
            }

            &:last-child{
                td:first-child{
                    border-radius: 0px 0px 0px 8px;
                }

                td:last-child{
                    border-radius: 0px 0px 8px 0px;
                }
                border-bottom: #F6F8FA;
            }

            .read-only{
                text-align: left;
                background-color: transparent;
                border: 0;
            }

            td.discussion-value-cell {
                text-align: center;
                width: 1%;
                white-space: nowrap;
            }

            td.discussion-value-cell .read-only {
                text-align: left;
            }

            .value-change{
                color: #4DAE49!important;
            }

            svg{
                color: #112A61;
                animation: flipInX;
                animation-duration: 2s;
            }

            .badge{
                color: #fff!important;
                background-color: #112A61;
                border-radius: 10rem;
                animation: flipInX;
                animation-duration: 1s;
            }
        }
    }
`;

export const CollapseStyled = styled(Collapse)`
    vertical-align: middle;
    background-color: rgb(250 250 250);
    animation: fadeIn !important;
    animation-duration: 1s !important;
`;

export const ChatWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  & > div {
    width: auto !important;
    max-width: 100%;
    display: flex;
    justify-content: center;
    line-height: normal;
  }

  button {
    min-width: 48px !important;
    width: auto !important;
    height: 40px !important;
    padding: 0 12px !important;
    margin: 0 !important;
    background-color: #112A61 !important;
    border-radius: 8px !important;
    border: none !important;
    display: inline-flex !important;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    position: relative;

    &:hover {
      background-color: #1a3a7a !important;
    }

    .discussion-chat-label {
      display: none !important;
    }

    .discussion-chat-inner {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
    }

    /* Não forçar cor no SVG: MdChat usa color={iconColor} (laranja=aberta, verde=fechada). */
    svg {
        font-size: 18px !important;
        margin: 0 !important;
        float: none !important;
    }

    .discussion-chat-inner .icon-newdiscussion {
        position: static !important;
        top: auto !important;
        right: auto !important;
        width: 8px !important;
        height: 8px !important;
        min-width: 8px !important;
        min-height: 8px !important;
        max-width: none !important;
        flex-shrink: 0 !important;
        border-radius: 50% !important;
        background-color: #ff4d4f !important;
        border: 2px solid rgba(255, 255, 255, 0.95) !important;
        box-sizing: content-box;
    }
  }
`;